import BlTaggingMv from './BlTaggingMv.vue'

BlTaggingMv.install = function(Vue) {
  Vue.component(BlTaggingMv.name, BlTaggingMv)
}

export default BlTaggingMv
